import { api } from "./api";
import type { DashboardSummary, DashboardDailyLogging } from "@/types/models";

export const dashboardService = {
  getSummary: (days = 7, date?: string): Promise<DashboardSummary> =>
    api
      .get<DashboardSummary>("/dashboard/summary", {
        params: { days, ...(date ? { date } : {}) },
      })
      .then((r) => r.data),
  getDailyLogging: (): Promise<DashboardDailyLogging> =>
    api.get<DashboardDailyLogging>("/dashboard/daily-logging").then((r) => r.data),
};
